module.exports = __webpack_public_path__ + "static/img/today.b8df67d1.png";